/**
 * Extracts up to 6 numeric digits from a pasted string.
 * Non-digit characters are stripped.
 */
export function parseOtpFromPaste(text) {
  return String(text).replace(/\D/g, '').slice(0, 6).split('');
}

/**
 * Returns true if the character is a single decimal digit.
 */
export function isValidOtpDigit(char) {
  return /^\d$/.test(char);
}
